import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    datas: [],
    totalCount: 0,
    detail: null,
    coinTypes: []
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item
      }));
    }
  },
  mutations: {
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
    setList(state, payload) {
      state.datas = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetail(state, payload) {
      state.detail = payload;
    }
  },
  actions: {
    getCoinTypes({ commit }) {
      api.getCoinTypes().then(({ data }) => {
        commit('setCoinTypes', data);
      });
    },
    reqList({ commit }, query) {
      api.reqList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    }
  }
};

appStore.registerModule('transferInner', store);
